module.exports = __webpack_public_path__ + "img/xw_hospital_logo@2x.4a9168c9.png";